import { useState } from "react";
import { useNavigate } from "react-router-dom";
import client from "@/lib/api";
import { ADMIN } from "@/constants/testIds";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const r = await client.post("/admin/login", { email, password });
      localStorage.setItem("nn_admin_token", r.data.token);
      localStorage.setItem("nn_admin_email", r.data.email);
      nav("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <main className="min-h-[80vh] flex items-center justify-center px-6 py-20">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="eyebrow mb-3">Admin</div>
          <h1 className="serif-title text-4xl text-[#0a1628]">Office sign-in.</h1>
          <p className="text-[#6b6b6b] text-[14px] mt-3">Access restricted to authorised administrators.</p>
        </div>
        <form data-testid={ADMIN.loginForm} onSubmit={submit} className="border hairline bg-white p-8 space-y-5">
          <div>
            <label className="label-sm">Email</label>
            <input data-testid={ADMIN.loginEmail} type="email" className="form-input" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div>
            <label className="label-sm">Password</label>
            <input data-testid={ADMIN.loginPassword} type="password" className="form-input" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          {error && <div className="text-[13px] text-red-700 border border-red-300 bg-red-50 p-3">{error}</div>}
          <button data-testid={ADMIN.loginSubmit} disabled={loading} className="btn w-full justify-center">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </main>
  );
}
